import { Component } from '@angular/core';
import { NavController, NavParams, Platform, AlertController, ToastController } from 'ionic-angular';
// import { PhotoLibrary } from '@ionic-native/photo-library';
import { PhotoLibrary } from './../../../providers/my-photo-library';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { AbstractPage } from '../../_com/abstract-page';
import { AuthStore } from '../../../stores/auth-store';
import { HttpReserveProvider } from '../../../providers/http-reserve';

/**
 * Generated class for the PhotoRequestConfirmPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-photo-request-confirm',
  templateUrl: 'photo-request-confirm.html',
})
export class PhotoRequestConfirmPage extends AbstractPage{

	memo = "";
	photos = [];
	photoChecks = {};
	data = {};
	selectedPhotos = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private pv:PhotoViewer, private pl:PhotoLibrary, private plt:Platform, private alertController:AlertController, private httpReserveProvider:HttpReserveProvider, private authStore:AuthStore, private toastController:ToastController) {
  	super();
  }

  ionViewDidLoad() {

    this.data = this.navParams.data["data"];
    this.photoChecks = this.navParams.data["photoChecks"];
    this.photos = this.navParams.data["photos"];
    this.memo = this.navParams.data["memo"];

    for(var index in this.photos){
    	var photo = this.photos[index];
      if(this.photoChecks[photo["Chat"]["id"]]){
      	this.selectedPhotos.push(photo);
      }
    }

    this.pl;
    this.pv;
    this.plt;    
  }

  /**
   * 選択済の写真を抽出
   */
  isSelectPhoto(photo){
  	return this.photoChecks[photo["Chat"]["id"]];
  }

  /**
   * 送信
   */
  send(){

    var p = {
      id:this.data["id"],
      photos:this.selectedPhotos,
      memo:this.memo,
      staffId:this.authStore.getLogin()["id"],
      date:new Date(),
    };

  	super.confirm(this.alertController, "写真データを送信します。よろしいですか？", ()=>{
      this.httpReserveProvider.replyPhotoRequest(p).subscribe(data=>{
        if(data["data"]){
          this.toast(this.toastController, "写真データを送信しました");
          this.navCtrl.popToRoot();
        }
      });
  	});
  }
}


// WEBPACK FOOTER //
// ./src/pages/photo-request/confirm/photo-request-confirm.ts